import { _Api } from "../../api/_call";
import { error, success } from "./toastify";

/**
 * Download Product master import sample (same Product sheet as product export).
 * @param {"xlsx"|"csv"} format
 * @param {(key: string) => string} [t]
 */
export const downloadProductSampleTemplate = async (
  format = "xlsx",
  t = (s) => s
) => {
  const exportFormat = String(format).toLowerCase() === "csv" ? "csv" : "xlsx";
  try {
    const res = await _Api(
      { format: exportFormat },
      "api/v1/App/productexport/productSampleTemplate"
    );
    if (res?.code === 200 && res?.filexlsx) {
      const a = document.createElement("a");
      a.hidden = true;
      a.href = res.filexlsx;
      a.download = `Product_Import_Sample.${exportFormat}`;
      a.target = "_blank";
      document.body.appendChild(a);
      a.click();
      a.remove();
      success(res?.message || t("Sample template downloaded"));
      return true;
    }
    error(res?.message || res?.error || t("Could not download sample template"));
    return false;
  } catch (err) {
    console.log(err, "downloadProductSampleTemplate");
    error(t("Could not download sample template"));
    return false;
  }
};
